import { render, staticRenderFns } from "./AreasList.vue?vue&type=template&id=459abc1c&scoped=true"
import script from "./AreasList.vue?vue&type=script&lang=js"
export * from "./AreasList.vue?vue&type=script&lang=js"
import style0 from "./AreasList.vue?vue&type=style&index=0&id=459abc1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459abc1c",
  null
  
)

export default component.exports